import React, {Component} from "react";
import {
  withStyles, TableContainer, Table, TableHead, TableBody, TableFooter,
  TableRow, TableCell, TablePagination, Box, IconButton, TextField
} from "@material-ui/core";
import {KeyboardArrowLeft, KeyboardArrowRight} from "@material-ui/icons";
import clsx from 'clsx';
import {observer} from "mobx-react";
import _ from "lodash";

import styles from "./styles";

@observer
class List extends Component {
  constructor(props) {
    super(props);
  }

  onPaginationChange = (field, value) => {
    const {store} = this.props;
    store.setFilter(field, value);
    if (field === 'size') {
      store.setFilter('page', 1);
    }
    store.search();
  }

  render() {
    const {classes, renderer, store, disablePagination, rows, schema, emptyResponse, rowActions, headerRenderer, hidden, blurCustomerInfo } = this.props;
    const {filters, headers, result} = store;

    const items = rows || (result && result.items) || [];
    const headerMap = schema || headers;
    const filteredHeaders = headerMap.filter(header => !hidden || hidden.length == 0 || !hidden.includes(header.name));

    if (!items.length) {
      return (
        <Box p={3} className={classes.notFound}>{emptyResponse || "Nothing found"}</Box>
      )
    }

    return (
      <TableContainer>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              {filteredHeaders.map(header => (
                <TableCell key={header.name} className={clsx({[classes.highlight]: header.highlight, [classes.tableHeader]: true})}>
                  {headerRenderer && headerRenderer[header.name] ? headerRenderer[header.name](header) : header.label}
                </TableCell>
              ))}
              {
                  rowActions && rowActions.map((action, i) => (
                      <TableCell key={`${action.name}_header_key`} className={classes.tableHeader}>
                        &nbsp;
                      </TableCell>))
              }
            </TableRow>
          </TableHead>
          <TableBody>
            {items.filter(row => !!row).map((row, i) => (
              <TableRow key={row.id || i}>
                {filteredHeaders.map(field => (
                  <TableCell scope="row" key={field.name}
                             className={clsx({
                               [classes.highlight]: field.highlight,
                               [classes.shrink]: field.shrink,
                               [classes.tableCell]: true,
                               [classes[field.name]]: !!classes[field.name],
                               [classes.textBlur]: Boolean(blurCustomerInfo && field.canBlur),
                             })}
                  >
                    {renderer[field.name] ? renderer[field.name](row, field.name, items) : _.get(row, field.name)}
                  </TableCell>
                ))}
                {
                  rowActions && rowActions.map((action, i) => (
                    <TableCell key={`${action.name}_key`} className={classes.tableCell} onClick={(e) => action.onClick(e, row)}>
                      {action.render(row)}
                    </TableCell>))
                }
              </TableRow>
            ))}
          </TableBody>
          {!disablePagination && (
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  colSpan={filteredHeaders.length}
                  count={result.count}
                  rowsPerPage={filters.size}
                  page={filters.page - 1}
                  SelectProps={{native: true}}
                  onPageChange={(e, page) => this.onPaginationChange("page", page + 1)}
                  onRowsPerPageChange={e => this.onPaginationChange("size", e.target.value)}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          )}
        </Table>
      </TableContainer>
    );
  }
}

const TablePaginationActions = withStyles(styles)(class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: props.page + 1,
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {page} = this.props;
    const {page: prevPage} = prevProps;
    if (prevPage !== page) {
      this.setState({currentPage: page + 1});
    }
  }

  handleBackButtonClick = (event) => {
    const {page, onPageChange} = this.props;
    onPageChange(event, page - 1);
  };

  handleNextButtonClick = (event) => {
    const {page, onPageChange} = this.props;
    onPageChange(event, page + 1);
  };

  onPageInput = (value) => {
    const {count, rowsPerPage} = this.props;
    let page = value;
    if (value) {
      page = isNaN(parseInt(value)) ? 1 : Math.max(parseInt(value), 1);
      page = Math.min(Math.ceil(count/rowsPerPage), page);
    }

    this.setState({currentPage: page});
  }

  changePage = (e) => {
    const {currentPage} = this.state;
    const {onPageChange} = this.props;

    if (!currentPage || isNaN(currentPage))
      return;

    if (e.which === 13)
      onPageChange(e, currentPage - 1);
  }

  render() {
    const {currentPage} = this.state;
    const {count, page, rowsPerPage, classes} = this.props;

    return (
      <Box className={classes.paginationBox}>
        <IconButton onClick={this.handleBackButtonClick} disabled={page === 0}>
          <KeyboardArrowLeft />
        </IconButton>
        <TextField
          value={currentPage}
          onChange={e => this.onPageInput(e.target.value)}
          onKeyPress={e => this.changePage(e)}
          className={classes.pageInputWrapper}
          inputProps={{className: classes.pageInput}}
          margin="dense"
        />
        <IconButton onClick={this.handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1}>
          <KeyboardArrowRight />
        </IconButton>
      </Box>
    );
  }
})

export default withStyles(styles)(List);
